<template>
    <div class="preview-doc">
        <div style="display: flex; justify-content: space-between;">
            <div class="doc-title">勞務報酬單</div>
            <div style="width: 15%">
                <div class="text-line"></div>
                <div class="text-line"></div>
                <div class="text-line"></div>
                <div class="text-line"></div>
            </div>
        </div>
        <table v-if="showPassbookImage" cellspacing="0" cellpadding="0">
            <tr>
                <th>存摺封面</th>
            </tr>
            <tr>
                <td><div style="width: 100%; aspect-ratio: 2.5;"></div></td>
            </tr>
        </table>
        <table v-if="showUnionInsuranceImage" cellspacing="0" cellpadding="0" style="margin-top: 10px;">
            <tr>
                <th>職業工會投保證明</th>
            </tr>
            <tr>
                <td><div style="width: 100%; aspect-ratio: 1.3;"></div></td>
            </tr>
        </table>
    </div>
</template>
<script>
export default {
    name: 'payment-export-pdf-dialog',
    props: {
        showPassbookImage: {
            type: Boolean,
            default: true,
        },
        showUnionInsuranceImage: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {

        };
    },
};
</script>
